import {AppState} from '..';

export const isFetching = (state: AppState) => state.i18n.isFetching;
export const locale = (state: AppState) => state.i18n.locale;
export const messages = (state: AppState) => state.i18n.messages;
export const error = (state: AppState) => state.i18n.error;
